import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../../store/store';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import WizardFilePreviewButton from './WizardFilePreviewButton';

loadDOMComponent({
	selector: 'react-wizard-preview-button',
	callback: ({ container, context }: any) => {
		const fileId = container.getAttribute('fileId');
		const title = container.getAttribute('title');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WizardFilePreviewButton fileId={fileId} title={title} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
